<template>
  <div class="notData">
    <img src="/images/nothing.png?x-oss-process=image/resize,m_lfit,h_200,w_200&d=200x200" alt="">
    <div>{{$t('noData')}}</div>
  </div>
</template>

<script>
import { loadLanguageAsync } from '../lib/i18n/index'
loadLanguageAsync('center')
export default {
  name: 'noData', 
  data () {
    return {
    }
  },
}
</script>

<style scoped lang="scss">
  .notData {
    width: 100%;
    background: #fff;
    padding: 0.7692rem 0;
    font-size: 0.6154rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 6.9231rem;
      height: 6.9231rem;
    }
    & /deep/.el-loading-mask {
      z-index: 10;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/notData.vue